import { COLORS } from 'constants/index';
import typography from '../typography';

const MuiFilledInput = {
  root: {
    backgroundColor: COLORS.WHITE,
    borderRadius: '4px',
    '&$error': {
      borderColor: COLORS.RED,
    },
    '&$focused': {
      backgroundColor: COLORS.WHITE,
      borderColor: COLORS.BLUE,
    },
    '&:hover': {
      backgroundColor: COLORS.WHITE,
      borderColor: COLORS.BLACK_6,
    },
    '&$disabled': {
      backgroundColor: COLORS.WHITE,
      '&:hover': {
        borderColor: COLORS.BLACK_12,
      },
    },
  },
  inputAdornedStart: {
    paddingBottom: 0,
  },
  adornedEnd: {
    paddingRight: '16px !important',
  },
  adornedStart: {
    paddingLeft: '16px !important',
  },
  input: {
    ...typography.body2,
    paddingLeft: '0px',
    paddingRight: '8px',
    paddingTop: '16px',
    paddingBottom: '4px',
    marginTop: '0',
    borderRadius: '4px !important',
    '&$disabled': {
      backgroundColor: COLORS.WHITE,
      color: COLORS.BLACK_3,
    },
  },
};

export default MuiFilledInput;
